import HelloWorld from './components/HelloWorld.vue';
import About from './components/AboutComponent.vue';
import Contact from './components/ContactComponent.vue';
import GraphQl from './components/GraphQlDataComponent.vue';

import changePassword from './components/changePassword.vue';
import changePasswordProxy from './components/changePasswordProxy.vue';
import passwordReset from './components/passwordReset.vue';
import profileView from './components/profileView.vue';
import searchPage from './components/searchPage.vue';
import landingPage from './components/landingPage.vue';
import signIn from './components/signIn.vue';
import signUp from './components/signUp.vue';
import storeProfile from './components/storeProfile.vue';
import updateProfile from './components/updateProfile.vue';
import userDashboard from './components/userDashboard.vue';
import proxy from './components/proxy.vue';
import deleteProfile from './components/deleteProfile.vue';
import logout from './components/logout.vue';

export default[
    {path:"/timeawards/",component: landingPage,props :true},
  //  {path:"/cli/:msg",component: HelloWorld,props:true },
  //  {path: "/about",component: About,props:{msg: "Welcome to Vue.js by binary whisperer"} },
   // {path:"/contact",component: Contact},
   // {path:"/graphql",component: GraphQl},
    {path:"/timeawards/profileView/awardee/:Id",component: profileView,props:true},
    {path:"/timeawards/searchPage/:searchString",component: searchPage,props:true },
    {path:"/timeawards/signIn",component: signIn},
    //{path:"/signUp",component: signUp},
    {path:"/timeawards/storeProfile",component: storeProfile},
    {path:"/timeawards/updateProfile/:profileId",component: updateProfile, props:true},
    {path:"/timeawards/userDashboard",component: userDashboard},
    {path:"/timeawards/changePassword/:hash",component: changePassword,props:true},
    {path:"/timeawards/Password/reset/verify/:hash",component: changePasswordProxy,props:true},
    {path:"/timeawards/passwordReset",component: passwordReset},
    {path:"/timeawards/proxy/:searchString",component: proxy,props:true },
    {path:"/timeawards/delete/profile/:profileId",component: deleteProfile,props:true },
    {path:"/timeawards/logout",component: logout}
]